import { render, staticRenderFns } from "./Copouns.vue?vue&type=template&id=1a0afa97&scoped=true&"
import script from "./Copouns.vue?vue&type=script&lang=js&"
export * from "./Copouns.vue?vue&type=script&lang=js&"
import style0 from "./Copouns.vue?vue&type=style&index=0&id=1a0afa97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0afa97",
  null
  
)

export default component.exports